<video #cameraElement [id]="'camera_' + camera?.id" style="width: 100%; height:100%;"  class="camera-media"></video>
